import { Fragment, useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { userService } from "../services/userService";

export default function UserModal({ isOpen, onClose, onSave, user }) {
  const [roles, setRoles] = useState([]);
  const [grades, setGrades] = useState([]);
  const [sections, setSections] = useState([]);

  // ✅ fetch roles
  const getRoles = async () => {
    try {
      let res = await userService.getAllRoles();
      let grades = await userService.getAllGrades();
      let sections = await userService.getAllSections();
setSections(sections.data);         
      setGrades(grades.data);      
      setRoles(res.data);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  useEffect(() => {
    if (isOpen) getRoles(); // only fetch when modal is open
  }, [isOpen]);

  // ✅ early return after hooks
  if (!isOpen) return null;
  // ✅ Validation schema
  const validationSchema = Yup.object({
    fullName: Yup.string().required("Full name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    phone: Yup.string().required("Phone number is required"),
    school: Yup.string().required("School name is required"),
    grade: Yup.string().required("Grade is required"),
  });

  // ✅ Default values for new user
  const defaultValues = {
    id: null,
    fullName: "",
    email: "",
    phone: "",
    role: "",
    school: "",
    grade: "",
    section: "",
    sendWelcome: false,
  };

  // ✅ If editing, prefill form with user data
  const initialValues = user ? { ...defaultValues, ...user } : defaultValues;

  console.log("Initial Values:", initialValues);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black bg-opacity-40"
        onClick={onClose}
      ></div>

      {/* Modal */}
      <div className="relative bg-white rounded-xl shadow-lg w-full max-w-2xl p-6">
        {/* Header */}
        <div className="flex justify-between items-center border-b pb-3 mb-4">
          <h2 className="text-lg font-semibold text-gray-900">
            {user ? "Edit User" : "Add New User"}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-xl"
          >
            ✕
          </button>
        </div>

        <div >
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              onSave(values);
              onClose();
            }}
          >
           

            
            {({ values }) => (
              <Form className="space-y-4">
                {/* Full Name */}

                 <div className="max-h-[750px] overflow-y-auto pr-2 scrollbar-hide"> 
                <div>
                  <label className="text-md text-[#717576] font-normal">
                    Full Name
                  </label>
                  <Field
                    name="fullName"
                    type="text"
                    placeholder="Enter full name here"
                    className="w-full border p-3 my-[9px] text-md bg-[#7175760F] h-[60px] rounded-[10px] focus:outline-none"
                  />
                  <ErrorMessage
                    name="fullName"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>

                {/* Email */}
                <div>
                  <label className="text-md text-[#717576] font-normal">
                    Email Address
                  </label>
                  <Field
                    name="email"
                    type="email"
                    placeholder="Enter email address"
                    className="w-full border p-3 my-[9px] text-md bg-[#7175760F] h-[60px] rounded-[10px] focus:outline-none"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>

                {/* Phone */}
                <div>
                  <label className="text-md text-[#717576] font-normal">
                    Phone Number
                  </label>
                  <Field
                    name="phone"
                    type="tel"
                    placeholder="Enter phone number"
                    className="w-full border p-3 my-[9px] text-md bg-[#7175760F] h-[60px] rounded-[10px] focus:outline-none"
                  />
                  <ErrorMessage
                    name="phone"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>

                {/* Roles */}
            <div className="mt-4">
  <label className="block text-sm font-medium text-gray-600 mb-2">
    Role
  </label>
  <div className="flex flex-wrap justify-between gap-4">
    {roles.map((role) => (
      <label
        key={role.role_id.toString()}
        className="flex items-center gap-2 text-gray-700"
      >
        <Field
          type="radio"          // ✅ change to radio
          name="role"           // ✅ same name for all radio buttons
          value={role.role_id.toString()}
          className="w-5 h-5 rounded border-[#ccc] focus:ring-0"
        />
        {role.role_name}
      </label>
    ))}
  </div>
</div>

                {/* School */}
                <div>
                  <label className="text-md text-[#717576] font-normal">
                    School
                  </label>
                  <Field
                    name="school"
                    type="text"
                    placeholder="Enter School Name"
                    className="w-full border p-3 my-[9px] text-md bg-[#7175760F] h-[60px] rounded-[10px] focus:outline-none"
                  />
                  <ErrorMessage
                    name="school"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>

                {/* Grade */}
                <div className="relative">
                  <Field
                    as="select"
                    name="grade"
                    className="w-full border py-2 px-4 text-md my-[9px] h-[60px] rounded-[10px] appearance-none pr-10 focus:outline-none"
                  >
                    <option value="">Select Grade</option>
                    {
                      grades.map(grade => (
                        <option key={grade.grade_id} value={grade.grade_id}>{grade.grade_name}</option>
                      ))
                    }
                    {/* <option value="Grade 1">Grade 1</option>
                    <option value="Grade 2">Grade 2</option>
                    <option value="Grade 3">Grade 3</option> */}
                  </Field>
                  <svg
                    width="20"
                    height="11"
                    viewBox="0 0 20 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                  >
                    <path d="M10 11L0 0L20 0L10 11Z" fill="black" />
                  </svg>
                </div>

                {/* Section */}
                <div className="relative">
                  <Field
                    as="select"
                    name="section"
                    className="w-full border py-2 px-4 text-md my-[9px] h-[60px] rounded-[10px] appearance-none pr-10 focus:outline-none"
                  >
                    <option value="">Select Section</option>{
                      sections.map(section => (
                        <option key={section.section_id} value={section.section_id}>{section.name}</option>
                      ))
                    }
                    {/* <option value="A">Section A</option>
                    <option value="B">Section B</option>
                    <option value="C">Section C</option> */}
                  </Field>
                  <svg
                    width="20"
                    height="11"
                    viewBox="0 0 20 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                  >
                    <path d="M10 11L0 0L20 0L10 11Z" fill="black" />
                  </svg>
                </div>

                {/* Send Welcome Email */}
                <div className="flex items-center gap-2">
                  <Field
                    type="checkbox"
                    name="sendWelcome"
                    className="w-5 h-5 rounded border-[#ccc] focus:ring-0"
                  />
                  <span className="text-sm text-gray-700">
                    Send Welcome Email to User
                  </span>
                </div>
                </div>

                {/* Footer */}
                <div className="flex justify-between gap-3 pt-4">
                  <button
                    type="button"
                    onClick={onClose}
                    className="px-4 py-4 w-full rounded-[10px] border border-brandBlue text-brandBlue bg-transparent hover:bg-brandBlue hover:text-white transition"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-4 w-full rounded-[10px] bg-brandBlue text-white hover:bg-primary-700 transition"
                  >
                    {user ? "Update Changes" : "Save & Add"}
                  </button>
                </div>
              </Form>
            )}
           
          </Formik>
        </div>
      </div>
    </div>
  );
}
